import React from "react";
import { Button, Modal, Progress } from "antd";
import { useTranslation } from "react-i18next";

const BulkExactModal = ({ visible, onClose, processing, progress, currentItem, results, itemType = "item" }) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t(`sending_${itemType}s_to_exact`)}
      open={visible}
      onCancel={processing ? undefined : onClose}
      footer={
        processing
          ? null
          : [
              <Button key="close" type="primary" onClick={onClose}>
                {t("close")}
              </Button>,
            ]
      }
      closable={!processing}
      maskClosable={false}
    >
      <div style={{ textAlign: "center", padding: "20px 0" }}>
        <Progress type="circle" percent={progress} status={processing ? "active" : "success"} />
        {processing && (
          <div style={{ marginTop: "16px" }}>
            <p>{t(`processing_${itemType}`)}:</p>
            <p style={{ fontWeight: "bold" }}>{currentItem}</p>
          </div>
        )}
        {!processing && progress === 100 && (
          <div style={{ marginTop: "16px" }}>
            <p style={{ color: "#52c41a", fontWeight: "bold" }}>{t("processing_complete")}</p>
            <p>
              {t("successful")}: {results.successful.length} | {t("failed")}: {results.failed.length}
            </p>
          </div>
        )}
      </div>
    </Modal>
  );
};

export default BulkExactModal;
